<div class="row">
  <ng-content></ng-content>
  @if (orderWidget !== null) {
    <div class="col-4 pe-0">
      <swiper-container
        [slidesPerView]="1"
        [autoplay]="false"
        init="false"
        #swiper
        class="position-relative promotions-carousel carousel"
        >
        <swiper-slide>
          <div class="image-wrapper">
            <img
              [src]="orderWidget.language_definitions[0].image_url"
              [alt]="orderWidget.language_definitions[0].title"
              class="img"
              (click)="gotoUrl(orderWidget)"
              loading="eager"
              fetchpriority="high"
              />
          </div>
          @if (applicationService.getSelectCompanyGroupCode() !== 'RAL') {
            <p class="title">{{ orderWidget.language_definitions[0].title }}</p>
          }
        </swiper-slide>
      </swiper-container>
    </div>
  }
  <div class="col-8 ps-1" [ngClass]="orderWidget !== null ? 'col-8 ps-0' : 'col-12'">
    @if (widgets && widgets.length) {
      <swiper-container
        [slidesPerView]="orderWidget ? 2 : 3"
        [navigation]="true"
        init="false"
        [autoplay]="{ delay: 7000 }"
        #swiper
        class="position-relative promotions-carousel carousel"
        >
        @for (slide of widgets; track slide; let i = $index) {
          @if (slide.language_definitions.length) {
            <swiper-slide>
              <div class="image-wrapper">
                <img
                  [src]="slide.language_definitions[0].image_url"
                  [alt]="slide.language_definitions[0].title"
                  class="img"
                  (click)="gotoUrl(slide)"
                  [attr.loading]="i === 0 ? 'eager' : 'lazy'"
                  [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
                  />
              </div>
              @if (applicationService.getSelectCompanyGroupCode() !== 'RAL') {
                <p class="title">{{ slide.language_definitions[0].title }}</p>
              }
            </swiper-slide>
          }
        }
      </swiper-container >
    }
  </div>
</div>
